<template>
  <div class="homepage">
    <div class="home">
      <div class="firstloggo">
        <component-logo imageWidth="130px" imageHeight="130px"></component-logo>
      </div>
      <div class="starth1">
        <h1>Kompetenskollen</h1>
      </div>
      <div class="startingress">
        <h2>
          Är du framtidens offentliga inköpare?
          <p></p>Kompetenskollen är ett unikt verktyg där du enkelt kartlägger din kompetens.
          Utifrån SOIs 13 kompetensområden bedömer du både dina styrkor och svagheter.
          Vill du veta var du står för att möta framtidens utmaningar?
        </h2>
      </div>
      <div class="startbtn">
        <router-link to="/section/0">
          <b-button>Starta kompetenskollen</b-button>
        </router-link>
      </div>
      <div class="knowmorebut">
        <button @click="show = !show" class="button3">
          Vill du veta mer?
          <span class="read">Läs här >></span>
        </button>
      </div>
      <div id="knowmoredesk" class="knowmoredesk" v-if="show">
        <div class="firstloggo">
          <component-logo imageWidth="130px" imageHeight="130px"></component-logo>
        </div>
        <h1>Kompetenskollen</h1>
        <h3>
          För att bli en framgångsrik inköpare behöver du dels en teoretisk utbildning, men också praktisk erfarenhet. Och ett intresse för goda affärer.
          <br>
          <br>
          <p>Med kompetenskollen bedömer du själv inom vilka områden du är stark och vilka du kan förbättra. Om du vill kan du också skicka resultatet till din mail.</p>
          <p>Kompetenskollen innehåller SOIs 13 olika kompetensområden och bedömer dig utifrån tre parametrar: utbildning, erfarenhet och intresse.</p>
          <p>Du är helt anonym och ingen information kopplat till dig som person kommer sparas.</p>
          <p style="color:#ec965b; font-weight: bold; margin-top:28px; margin-bottom:28px;">
            Kompetenskollen är till för dig
            som:
          </p>
          <div class="row">
            <div class="col-1">
              <p>-</p>
              <br>
              <p>-</p>
              <br>
              <p>-</p>
            </div>
            <div class="col-11">
              <div class="textparts">
                <p>
                  Är yrkesverksam och vill veta inom vilka områden du kan förbättras,
                  eller vill bedöma din kompetens inför t.ex. ett utvecklingssamtal.
                </p>
                <p>Är chef och vill få en överblick över kompetensområden organisationen har eller saknar.</p>
                <p>Är nyfiken på om rollen som offentlig inköpare skulle passa dig.</p>
              </div>
            </div>
          </div>
        </h3>
        <div class="startbt">
          <router-link to="/section/0">
            <b-button>Starta kompetenskollen</b-button>
          </router-link>
        </div>
      </div>
    </div>
    <div class="mobilhome">
      <div class="mobilloggo">
        <component-logo imageWidth="85px" imageHeight="85px"></component-logo>
      </div>
      <div class="starth1">
        <h1>Kompetenskollen</h1>
      </div>
      <div class="startingress">
        <h2>
          Är du framtidens offentliga inköpare?
          <p></p>Kompetenskollen är ett unikt verktyg där du enkelt kartlägger din kompetens.
        </h2>
      </div>
      <div class="startbtn">
        <router-link to="/section/0">
          <b-button>Starta kompetenskollen</b-button>
        </router-link>
      </div>
      <div class="vetmermob">
        <button @click="showMobile = !showMobile" class="button3">
          Vill du veta mer?
          <span class="read">Läs här >></span>
        </button>
      </div>
      <transition name="slide-fade">
        <div id="knowmoremob" class="knowmoremob" v-if="showMobile">
          <button @click="showMobile = !showMobile" class="button3">
            <a class="close"></a>
          </button>
          <div class="mobilloggo2" style="margin-top:-8px;">
            <component-logo imageWidth="85px" imageHeight="85px"></component-logo>
          </div>
          <h1>Kompetenskollen</h1>
          <h3>
            För att bli en framgångsrik inköpare behöver du dels en teoretisk utbildning, men också praktisk erfarenhet. Och ett intresse för goda affärer.
            <br>
            <br>
            <p>Med kompetenskollen bedömer du själv inom vilka områden du är stark och vilka du kan förbättra. Om du vill kan du också skicka resultatet till din mail.</p>
            <p>Kompetenskollen innehåller SOIs 13 olika kompetensområden och bedömer dig utifrån tre parametrar: utbildning, erfarenhet och intresse.</p>
            <p>Du är helt anonym och ingen information kopplat till dig som person kommer sparas.</p>
            <p style="color:#ec965b; font-weight: bold;">
              Kompetenskollen är till för dig
              som:
            </p>
            <div class="row">
              <div class="col-1">
                <p>-</p>
                <br>
                <br>
                <br>
                <p>-</p>
                <br>
                <br>
                <p>-</p>
              </div>
              <div class="col-2">
                <div class="textparts">
                  <p>
                    Är yrkesverksam och vill veta inom vilka områden du kan förbättras,
                    eller vill bedöma din kompetens inför t.ex. ett utvecklingssamtal.
                  </p>
                  <p>Är chef och vill få en överblick över kompetensområden organisationen har eller saknar.</p>
                  <p>Är nyfiken på om rollen som offentlig inköpare skulle passa dig.</p>
                </div>
              </div>
            </div>
          </h3>
          <div class="startbt">
            <router-link to="/section/0">
              <b-button>Starta kompetenskollen</b-button>
            </router-link>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<style scoped lang="scss">
.slide-fade-enter-active {
  transition: all 0.8s ease-in;
}
.slide-fade-leave-active {
  transition: all 0.8s ease-in;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-100%);
  opacity: 0;
}

.home {
  width: 100%;
  background-image: url("../assets/desktop-start.jpg");
  background-size: cover;
  height: 100%;
  position: absolute;
  overflow: scroll;
  overflow-x: hidden;
  @media (max-width: 991px) {
    display: none;
  }
  @media (min-width: 991px) {
    border: 20px solid white;
  }
}
.knowmorebut {
  text-align: center;
}
.knowmoremob {
  width: 100%;
  height: 100%;
  bottom: 0;
  position: fixed;
  background-color: #22547f;
  z-index: 5;
  overflow: scroll;
  overflow-x: hidden;
  h1 {
    font-size: 32px !important;
    color: #fff;
    margin-bottom: 37px;
    margin-top: 67px;
  }
  h3 {
    font-size: 16px !important;
    width: 305px !important;
    margin: 0 auto;
    color: #fff;
    font-family: "museo-sans";
    text-align: left;
  }
  .textparts {
    width: 270px;
    margin-left: -15px;
    text-align: left;
  }
  .startbt {
    margin-bottom: 48px;
  }
}
.vetmermob {
  text-align: center;
  margin-bottom: 32px;
}
.button3 {
  background-color: transparent !important;
  color: #fff;
  margin-top: 0px;
  outline: none;
}
.read {
  text-decoration: underline;
  white-space:nowrap;
}
.mobilhome {
  width: 100%;
  background-image: url("../assets/mobile-start.jpg");
  background-size: cover;
  height: 100%;
  position: absolute;
  display: none;
  overflow: scroll;
  overflow-x: hidden;
  h1 {
    font-size: 32px !important;
  }
  h2 {
    font-size: 16px !important;
    width: 230px !important;
    margin-bottom: 8px !important;
    color: #fff;
    font-family: "museo-sans";
  }
  button {
    height: 48px !important;
    width: 225px !important;
    font-size: 16px !important;
    margin-top: 16px !important;
    text-align: center;
  }
  @media (max-width: 991px) {
    display: block;
  }
}
.knowmoremob {
  font-family: "museo-sans";
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  a {
    color: #fff !important;
    text-decoration: underline;
  }
}
.mobilloggo {
  margin-top: 62px;
  text-align: center;
}
.starth1 h1 {
  color: #fff;
  text-align: center;
  font-family: "museo-slab";
  font-size: 48px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  margin-top: 144px;
  margin-bottom: 28px;
}
.startingress h2 {
  font-family: "museo-sans";
  font-size: 24px;
  color: #fff;
  text-align: center;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  width: 800px;
  margin: 0 auto;
}
.knowmore {
  font-family: "museo-sans";
  font-size: 24px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  a {
    color: #fff !important;
    text-decoration: underline;
  }
}
.knowmoredesk {
  width: 100%;
  top: 0;
  position: absolute;
  background-image: url("../assets/desktop-start.jpg");
  background-size: cover;
  z-index: 5;
  overflow-y: hidden;
  overflow-x: hidden;
  h1 {
    font-size: 48px !important;
    color: #fff;
    margin-bottom: 37px;
    margin-top: 67px;
    font-family: "museo-sans";
    text-align: center;
  }
  h3 {
    font-size: 24px !important;
    width: 800px !important;
    margin: 0 auto;
    color: #fff;
    font-family: "museo-sans";
    text-align: left;
  }
  .textparts {
    margin-left: -30px;
    margin-right: 12px;
  }
  .startbt {
    margin-bottom: 48px;
    text-align: center;
  }
}
button {
  background-color: #ec965b !important;
  border: none;
  width: 337px;
  height: 72px;
  font-family: "museo-sans";
  font-size: 24px;
  margin-top: 60px;
  margin-bottom: 0px;
  border-radius: 0;
}
.firstloggo {
  margin-top: 123px;
  text-align: center;
}
.startbtn {
  text-align: center;
}
@media (max-width: 991px) {
  .frontsvg {
    display: none !important;
  }
}
.close {
  position: absolute;
  right: 14px;
  top: 24px;
  width: 32px;
  height: 20px;
  opacity: 1;
}
.close:hover {
  opacity: 1;
}
.close:before,
.close:after {
  position: absolute;
  left: 15px;
  content: " ";
  height: 20px;
  width: 3px;
  background-color: #fff;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}
</style>

<script>
import Logo from "../components/Logo";

export default {
  name: "home",
  components: {
    "component-logo": Logo
  },
  data () {
    return {
      show: false,
      showMobile: false
    };
  }
};
</script>
